import { Pipe, PipeTransform } from '@angular/core';
import { DateConversionService } from '../services/date-conversion.service';

@Pipe({
  name: 'isoPeriod',
  standalone: true
})
export class IsoToFormattedPeriodPipe implements PipeTransform {

  constructor(private dateConversionService: DateConversionService) { }

  transform(isoTimestamp: string): string {
    return this.dateConversionService.isoToFormattedPeriod(isoTimestamp);
  }
}
